/*@ngInject*/
const ReportActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadReportActions = function (reportId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.externaldata.ExternalReport:' + reportId + '&registrationIdentifier=/ExternalReport/' + reportId,
            cacheKey = 'reportActions:' + reportId;

        if (currentSubmissionModel.hasActionsRegistration('/ExternalReport/' + reportId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/ExternalReport/' + reportId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('reportActionsRepository', ReportActionsRepository);
